<svg id="refresh-bold.svg" [attr.width]="width" [attr.height]="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M12 2C7.55999 2 3.78999 4.91 2.48999 8.93L5.33999 9.85C6.24999 7.04 8.88999 5 12 5C14.14 5 16.09 5.95 17.41 7.57L15.3 9.21L22 11.05L21.89 4.1L19.78 5.73C17.9 3.4 15.03 2 12 2Z"
        [attr.fill]="color" />
    <path
        d="M11.99 22C16.44 22 20.21 19.08 21.51 15.05L18.66 14.13C17.75 16.95 15.11 19 12 19C9.86 19 7.91 18.05 6.59 16.43L8.7 14.79L2 12.95L2.11 19.9L4.22 18.27C6.1 20.6 8.97 22 12 22H11.99Z"
        [attr.fill]="color" />
</svg>